const quickLinks = [
  { label: "今日看点", href: "#featured" },
  { label: "话题广场", href: "#square" },
  { label: "观点擂台", href: "#arena" },
  { label: "热议榜", href: "#ranking" },
  { label: "常见问题", href: "#faq" },
];

const categoryLinks = ["娱乐八卦", "影视综艺", "体育竞技", "科技数码", "社会话题", "网络热点"];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold">黑料看点</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              话题讨论与争议热评聚集地。围绕热点事件展开多角度讨论，呈现不同立场的声音，让舆论动态看得见。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="cursor-pointer text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">热门分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categoryLinks.map((item) => (
                <li key={item}>
                  <a
                    href="#square"
                    className="cursor-pointer text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">联系与投稿</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-300"></i>
                hello@heiliaokandian.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-send-plane-line text-accent-300"></i>
                话题投稿：contribute@heiliaokandian.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-300"></i>
                热点更新：全天候跟进
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-primary-800 pt-6">
          <p className="text-xs leading-relaxed text-background-400">
            免责声明：本站话题与评论均为网友讨论观点的汇总呈现，仅作参考，不构成对任何具体人事的事实认定。请理性看待、文明表达，切勿传播未经证实的信息。
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-background-400">© 2026 黑料看点 · 保留所有权利</p>
            <p className="text-xs text-background-400">
              倡导理性讨论 · 拒绝网络暴力与隐私曝光
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}